import { DashboardItemProvider } from "./../interfaces/dashboard-item-provider"
import { Widget } from "./../models/widget";
import { Injectable } from "@angular/core";
import { DashboardItem } from "./../models/dashboard-item"


@Injectable()
export class DashboardItemProviderService implements DashboardItemProvider {
  protected  dashboardItems: Array<Widget>;

  static itemInit(item, itemComponent) {
    // this should be an action as it mutates state otherwise
    item.init = true;
  }

  protected createItem(dashboardName: string, title: string, rows?: number, cols?: number, hasImage?: boolean, widgetName?: string, resizeEnabled: boolean = true, dragEnabled = true, enabled = true) {
    const item = new DashboardItem();
    item.title = title;
    if (rows) item.rows = rows;
    if (cols) item.cols = cols;
    if (hasImage) item.hasImage = hasImage;
    if (widgetName) item.widgetName = widgetName;
    if (dashboardName) item.dashboardName = dashboardName;
    item.resizeEnabled = resizeEnabled;
    item.dragEnabled = dragEnabled;
    item.disabled = !enabled;
    return item;
  }

  getGridOptions() {
    const options = {};

    return options;
  }

  getDashboardItems(source: string, isLicensedForMCi?: boolean, inPreviewMode?: boolean): Widget[] {
    return [];
  }

  constructor() {
  }
}

